import { useLanguage } from '../context/LanguageContext';
import { Eye, Unlock, CheckCircle, Users } from 'lucide-react';

// Benefits image URL
const BENEFITS_IMAGE = "https://customer-assets.emergentagent.com/job_satya-self/artifacts/fxuvaogl_10%20benefits%20hebrew.png";

const SatyaSection = () => {
  const { t, language } = useLanguage();

  const benefits = [
    { key: 'satya_benefit1', icon: Eye },
    { key: 'satya_benefit2', icon: Unlock },
    { key: 'satya_benefit3', icon: CheckCircle },
    { key: 'satya_benefit4', icon: Users },
  ];

  return (
    <section 
      id="satya"
      className="py-20 md:py-28"
      style={{ backgroundColor: 'var(--sage-50)' }}
      data-testid="satya-section"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Section Title */}
        <h2 
          className="text-3xl md:text-4xl text-center mb-6"
          style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--charcoal)' }}
        >
          {t('satya_title')}
        </h2>

        {/* Intro */}
        <p className="text-base md:text-lg text-gray-600 text-center max-w-4xl mx-auto mb-4 leading-relaxed">
          {t('satya_intro')}
        </p>

        {/* Philosophy */}
        <p 
          className="text-base text-center max-w-2xl mx-auto mb-12 md:mb-16 leading-relaxed font-medium"
          style={{ color: 'var(--sage-700)' }}
        >
          {t('satya_philosophy')}
        </p>

        {/* Benefits Image - Hebrew only (image contains Hebrew text) */}
        {language === 'he' && (
        <div className="mb-12 md:mb-16">
          <div className="max-w-3xl mx-auto">
            <img 
              src={BENEFITS_IMAGE}
              alt="מה מפיקים מאימון בשיטת סאטיה?"
              className="w-full h-auto rounded-2xl shadow-lg"
              data-testid="satya-benefits-image"
            />
          </div>
        </div>
        )}

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-12">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div 
                key={benefit.key}
                className="bg-white p-6 md:p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300"
                data-testid={`satya-benefit-${index}`}
              >
                <div className="flex items-start gap-4">
                  <div 
                    className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: 'var(--sand-100)' }}
                  >
                    <Icon size={24} style={{ color: 'var(--sage-600)' }} />
                  </div>
                  <div>
                    <h3 
                      className="text-xl font-medium mb-2"
                      style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--charcoal)' }}
                    >
                      {t(`${benefit.key}_title`)}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {t(`${benefit.key}_desc`)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Quote */}
        <div className="text-center space-y-3">
          <p 
            className="text-xl md:text-2xl italic"
            style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--sage-700)' }}
          >
            {t('satya_quote')}
          </p>
          <p 
            className="text-sm"
            style={{ color: 'var(--sand-600)' }}
          >
            {t('satya_quote_author')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default SatyaSection;
